import {Box, Stack, Typography} from "@mui/material";
import {useApiManager} from "../../../components/utils/api";
import {FormContent} from "../../../components/form/form_inputs/form_buttons";
import {useForm, UseFormProps} from "../../../components/form/form_model";
import {EmployeeData, EmployeeRestControllerApiFactory} from "arteco-api-client-ts";
import {EmployeeDataFields} from "../../../components/layout/shared/person/employee_data";
import {useAuthManager} from "../../../components/utils/auth";
import {dateToString} from "../../../components/utils/dates";
import {fullName, Page, PageHeader, Panel, PersonAvatar} from "../../../components/kit";

/**
 * Mis datos: cabecera con la persona y, debajo, el mismo formulario que usa RR. HH.
 * (EmployeeDataFields), que no se toca aquí.
 */
export const EmployeeInfoPage = () => {
	const apiManager = useApiManager();
	const employeeCtrl = apiManager.factory(EmployeeRestControllerApiFactory);
	const authManager = useAuthManager();

	const employeeForm = useForm({
		fetcher: (_) => employeeCtrl.viewEmployeeInfo(),
		updater: (bean) => employeeCtrl.updateEmployeeInfo(bean),
		factory: () => employeeCtrl.viewEmployeeInfo(),
		modelIdFetcher: () => authManager.getUserId()
	} as UseFormProps<EmployeeData>);

	const loaded = !employeeForm.isLoading();
	const name = loaded ? fullName({name: employeeForm.value("name"), surnames: employeeForm.value("surnames")}) : "";
	const email = loaded ? employeeForm.value("email") : undefined;
	const hireDate = loaded ? employeeForm.value("hireDate") : undefined;

	return (
		<Page>
			<PageHeader title="Mis datos" subtitle="Tus datos personales y de contacto. Si algo no se puede cambiar aquí, pídeselo a RR. HH."/>

			{name && (
				<Panel sx={{mb: 3}}>
					<Stack direction="row" spacing={2} alignItems="center">
						<PersonAvatar name={name} size={56}/>
						<Box sx={{minWidth: 0}}>
							<Typography variant="subtitle1" fontWeight={700} noWrap>{name}</Typography>
							{email && <Typography variant="body2" color="text.secondary" noWrap>{email}</Typography>}
							{hireDate && <Typography variant="caption" color="text.secondary">En Arteco desde el {dateToString(hireDate)}</Typography>}
						</Box>
					</Stack>
				</Panel>
			)}

			<Panel>
				<FormContent hideMetadata={true} withoutPaper form={employeeForm}>
					<EmployeeDataFields lockFields
										photoDownloader={() => employeeCtrl.viewEmployeePhoto(employeeForm.getIdOrErr())}/>
				</FormContent>
			</Panel>
		</Page>
	);
};
